import React from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import api from '../../services/api';

const Terms = () => {
  const { type } = useParams(); // 'terms' 또는 'privacy'
  const contentType = type === 'privacy' ? 'privacy_policy' : 'terms_of_service';

  const { data: content, isLoading } = useQuery(
    [`${contentType}-content`],
    () => api.get(`/public/site-contents/${contentType}`),
    {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 10 * 60 * 1000,
      onError: (error) => {
        console.log('콘텐츠를 불러올 수 없습니다:', error);
      }
    }
  );

  if (isLoading) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-3/4 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-4/6"></div>
        </div>
      </div>
    );
  }

  if (!content?.data) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow p-8 text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            {type === 'privacy' ? '개인정보처리방침' : '이용약관'}
          </h1>
          <p className="text-gray-600">
            콘텐츠가 아직 등록되지 않았습니다.
          </p>
        </div>
      </div>
    );
  }

  const pageContent = content.data;

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          {pageContent.title || (type === 'privacy' ? '개인정보처리방침' : '이용약관')}
        </h1>
        {pageContent.version && (
          <p className="text-sm text-gray-500 mb-6">
            버전 {pageContent.version} | 최종 수정일: {pageContent.updated_at ? new Date(pageContent.updated_at).toLocaleDateString('ko-KR') : '-'}
          </p>
        )}
        <div
          className="prose max-w-none text-gray-700"
          dangerouslySetInnerHTML={{ __html: pageContent.content || '' }}
        />
      </div>
    </div>
  );
};

export default Terms;

